import { CobaltSearchField } from '@cae/cobalt-react/components/search-field';
import { useDocumentsFilter } from '@features/documents/contexts/documents-filter/useDocumentsFilter';
import { useSearchField } from '@shared/hooks/use-search-field/useSearchField';
import * as React from 'react';

import type { DocumentsSearchProps } from './DocumentsSearch.types';

import styles from './DocumentsSearch.module.css';

const DocumentsSearch = React.memo(
  ({
    disabled = false,
    onActivate,
  }: Readonly<DocumentsSearchProps>): React.ReactElement => {
    const { filters, setFilters } = useDocumentsFilter();
    const { localValue, handleChange, handleClear } = useSearchField({
      value: filters.searchText,
      onSearch: (searchText: string) =>
        setFilters({ searchText, folderId: null, parentFolders: [] }),
    });

    if (onActivate) {
      return (
        <div
          role="button"
          tabIndex={0}
          onClick={onActivate}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onActivate();
            }
          }}
          className={styles.documentsSearch}
          data-testid="documents-search-activate"
        >
          <CobaltSearchField
            placeholder="Search by document name"
            value=""
            disabled={disabled}
            className={styles.searchField}
          />
        </div>
      );
    }

    return (
      <CobaltSearchField
        hasClear
        placeholder="Search by document name"
        value={localValue}
        onChange={handleChange}
        onClear={handleClear}
        disabled={disabled}
        className={styles.documentsSearch}
        data-testid="documents-search"
      />
    );
  }
);

DocumentsSearch.displayName = 'DocumentsSearch';

export { DocumentsSearch };
